{
  "page": {
    "title": "Corespondență",
    "tabs": {
      "contacts": "Contacte",
      "lists": "Liste de corespondență",
      "emails": "E-mailuri"
    },
    "search": "Caută",
    "searchPlaceholder": "Nume sau e-mail…",
    "tag": "Etichetă",
    "allTags": "Toate etichetele",
    "newContact": "Contact nou",
    "emptyHeading": "Niciun contact",
    "emptyManage": "Adaugă contacte externe (non-elevi) pentru a le trimite e-mailuri alături de elevi.",
    "emptyPlain": "Niciun contact găsit.",
    "subscribed": "Abonat",
    "unsubscribed": "Dezabonat",
    "editContact": "Editează contactul",
    "firstName": "Prenume",
    "lastName": "Nume",
    "email": "E-mail",
    "phoneOptional": "Telefon (opțional)",
    "relationshipOptional": "Relație (opțional)",
    "relationshipPlaceholder": "ex. Părinte al lui …",
    "tags": "Etichete",
    "subscribedToggle": "Abonat la e-mailuri",
    "saveContact": "Salvează contactul",
    "edit": "Editează",
    "delete": "Șterge"
  },
  "columns": {
    "name": "Nume",
    "email": "E-mail",
    "phone": "Telefon",
    "relationship": "Relație",
    "tags": "Etichete",
    "subscribed": "Abonat",
    "type": "Tip",
    "status": "Statut"
  },
  "lists": {
    "newList": "Listă nouă",
    "byAuthor": "de {name}",
    "noSavedLists": "Nicio listă salvată încă.",
    "editList": "Editează lista",
    "listName": "Numele listei",
    "listNamePlaceholder": "ex. Începători activi",
    "audience": "Public",
    "audienceStudents": "Doar elevi",
    "audienceContacts": "Doar contacte",
    "audienceBoth": "Elevi + contacte",
    "studentStatus": "Statut elev",
    "any": "Oricare",
    "active": "Activ",
    "inactive": "Inactiv",
    "enrolledClass": "Înscris la clasa",
    "anyClass": "Orice clasă",
    "danceType": "Tip de dans",
    "anyDanceType": "Orice tip de dans",
    "level": "Nivel",
    "anyLevel": "Orice nivel",
    "paymentStatus": "Statut plată",
    "paidUp": "La zi",
    "hasOverdue": "Are restanțe",
    "hasPending": "Are în așteptare",
    "eventParticipant": "Participant la eveniment",
    "anyEvent": "Orice eveniment",
    "minAge": "Vârstă minimă",
    "minAgePlaceholder": "ex. 5",
    "maxAge": "Vârstă maximă",
    "maxAgePlaceholder": "ex. 18",
    "contactsTagsOnly": "Contactele sunt filtrate doar după etichete — filtrele pentru elevi nu se aplică.",
    "tagsLabelBoth": "Etichete (elevi + contacte) — corespunde oricăreia selectate",
    "tagsLabelContacts": "Etichete (contacte) — corespunde oricăreia selectate",
    "saveChanges": "Salvează modificările",
    "saveList": "Salvează lista",
    "deleteList": "Șterge lista",
    "resolving": "Se calculează…",
    "recipientCount_one": "{count} destinatar",
    "recipientCount_other": "{count} destinatari",
    "canBeEmailed": "{count} pot primi e-mail",
    "showingFirst": " · se afișează primii {count}",
    "noRecipients": "Niciun destinatar nu corespunde acestor filtre.",
    "unsubscribedPill": "dezabonat"
  },
  "emails": {
    "newEmail": "E-mail nou",
    "noSubject": "(fără subiect)",
    "sentCount": "{count} trimise",
    "noList": "fără listă",
    "noEmails": "Niciun e-mail încă.",
    "editDraft": "Editează ciorna",
    "sentEmail": "E-mail trimis",
    "to": "Către",
    "listFallback": "listă",
    "recipientCount_one": "{count} destinatar",
    "recipientCount_other": "{count} destinatari",
    "cloneAsDraft": "Clonează ca ciornă",
    "recipients": "Destinatari",
    "showSendError": "Arată eroarea de trimitere",
    "noErrorDetailShort": "Nu a fost înregistrat niciun detaliu al erorii",
    "sendError": "Eroare la trimitere",
    "deliveryFailedPre": "Livrarea către",
    "deliveryFailedPost": "a eșuat cu:",
    "noErrorDetailFailure": "Nu a fost înregistrat niciun detaliu al erorii pentru acest eșec.",
    "close": "Închide"
  },
  "compose": {
    "newEmail": "E-mail nou",
    "subject": "Subiect",
    "sendToList": "Trimite către lista de corespondență",
    "chooseList": "Alege o listă…",
    "noListsYet": "Nicio listă de corespondență încă — creează una mai întâi în fila Liste de corespondență.",
    "message": "Mesaj",
    "footerNote": "Trimis de la adresa de e-mail configurată a școlii. Un link de dezabonare este adăugat automat.",
    "saveDraft": "Salvează ciorna",
    "preview": "Previzualizare",
    "sendTest": "Trimite test",
    "sendEllipsis": "Trimite…",
    "emailPreview": "Previzualizare e-mail",
    "fromLine": "De la adresa de e-mail configurată a școlii · destinatarii pot răspunde",
    "emptyMessage": "_(mesaj gol)_",
    "unsubLong": "Ai primit acest e-mail de la școala ta. Dacă nu mai dorești să primești aceste e-mailuri,",
    "unsubShort": "Ai primit acest e-mail de la școala ta.",
    "unsubLink": "dezabonează-te aici",
    "sendEmail": "Trimite e-mail",
    "mailingList": "Listă de corespondență",
    "counting": "Se numără…",
    "emailable_one": "{count} destinatar contactabil",
    "emailable_other": "{count} destinatari contactabili",
    "matchedUnsub": "· {total} găsiți, {count} dezabonați",
    "messagePreview": "Previzualizare mesaj",
    "collapse": "Restrânge",
    "expand": "Extinde",
    "sendTestToMe": "Trimite-mi un test",
    "sendTestTitle": "Trimite test către {email}",
    "yourEmail": "e-mailul tău",
    "sendToCount": "Trimite către {count}",
    "send": "Trimite"
  },
  "status": {
    "draft": "Ciornă",
    "sent": "Trimis",
    "pending": "În așteptare",
    "failed": "Eșuat",
    "scheduled": "Programat"
  },
  "toast": {
    "contactNameRequired": "Prenumele și numele sunt obligatorii",
    "contactEmailRequired": "E-mailul este obligatoriu",
    "contactSaved": "Contact salvat",
    "contactSaveFailed": "Salvarea contactului a eșuat",
    "contactDeleted": "Contact șters",
    "confirmDeleteContact": "Ștergi contactul „{name}”?",
    "listNameRequired": "Dă un nume listei",
    "listSaved": "Listă de corespondență salvată",
    "listSaveFailed": "Salvarea a eșuat",
    "listDeleted": "Listă de corespondență ștearsă",
    "confirmDeleteList": "Ștergi lista de corespondență „{name}”?",
    "draftSubjectRequired": "Dă un subiect e-mailului",
    "draftSaved": "Ciornă salvată",
    "draftSaveFailed": "Salvarea ciornei a eșuat",
    "sendSubjectRequired": "Adaugă un subiect înainte de trimitere",
    "bodyEmpty": "Conținutul e-mailului este gol",
    "listRequired": "Alege o listă de corespondență către care să trimiți",
    "emailSent": "E-mail trimis",
    "sendFailed": "Trimiterea a eșuat",
    "testSubjectRequired": "Adaugă un subiect înainte de a trimite un test",
    "testValidated": "Test validat (sandbox — nelivrat); ar fi mers către {email}",
    "testSent": "E-mail de test trimis către {email}",
    "testFailed": "Trimiterea testului a eșuat",
    "cloned": "Clonat ca ciornă nouă",
    "confirmDeleteEmail": "Ștergi acest e-mail?",
    "emailDeleted": "E-mail șters"
  }
}
